<template>
<a v-bind="$attrs" v-if="isLocal" :class="{'active': isActive}" @click.prevent="goRealSmooth" :href="myUrl">
    <slot></slot>
</a>
<a v-bind="$attrs" v-else :href="myUrl" target="_blank">
    <slot></slot>
</a>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { computed } from 'vue';
const $ = window.jQuery;


// Convert prop href to URL object with
// consistent origin and trailing slash

export const normalize = (href) => {

    if (href.charAt(0) == '#') {
        return new URL(window.location.origin + window.location.pathname + href);
    }

    if (href.charAt(0) == '/') {
        let output = '';
        output = window.location.origin + href;

        // Static files
        if (href.indexOf('.') != -1) {
            return new URL(output);
        }

        if (output.at(-1) != '/') {
            let testUrl = new URL(output);
            return testUrl.hash.length
                ? testUrl
                : new URL(output + '/');
        }

        return new URL(output);
    }

    return new URL(href);

};

const onSamePage = (url) => {
    return window.location.origin == url.origin && window.location.pathname == url.pathname;
};

export default {

    props: {
        href: {
            type: String,
            required: true
        },
        preLoad: {
            type: Function,
            required: false
        }
    },

    setup(props) {

        const myUrl = computed(() => normalize(props.href));

        const goRealSmooth = async(e) => {

            if (props.preLoad) {
                await props.preLoad();
            }

            // Animate Anchor Links on Same Page
            // =================================

            if (myUrl.value.hash.length && onSamePage(myUrl.value)) {
                let target = $(myUrl.value.hash);
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 600);
                return false;
            }

            // Trigger Inertia
            // ===============

            let announce = new CustomEvent("goingSomewhereElse", {
                detail: {
                    href: myUrl.value.toString()
                }
            });
            window.dispatchEvent(announce);
            if (!window.prefersReducedMotion()) {
                await window.wait(380);
            }
            
            Inertia.get(myUrl.value.toString());

        }

        const isLocal = computed(() => {
            if (myUrl.value.pathname.indexOf('.') != -1) {
                return false; // to avoid inertia screwing up static file links
            }
            if (onSamePage(myUrl.value)) {
                return true;
            }
            return (myUrl.value.host == window.location.host);
        });

        const isActive = computed(() => {
            return (myUrl.value.hash.length)
                ? false
                : onSamePage(myUrl.value);
        });

        return {
            goRealSmooth,
            isActive,
            isLocal,
            myUrl: myUrl.value.toString()
        }
    }
}
</script>